<template>
  <mt-popup
             v-model="show"
             class="popup-ui"
             position="bottom"
             :teleport="teleport"
             :closeOnClickModal='false'
             :round="true"
             :lockScroll="true">
    <div class="popup-container">
      <div class="popup-top">
        <span class="title"
              :style="[{ textAlign: titleAlign || 'center' }]">{{ title }}</span>
        <i class="iconfont icon-close" :class="PostUiIcon.close"
           @click="() => { $emit('close') }" />
      </div>
      <div class="popup-main">
        <slot />
      </div>
      <div v-if="confirmBtn"
           class="popup-bottom">
        <button type="button"
                class="confirm-btn"
                @click="$emit('confirm')">
          {{ confirmBtnText }}
        </button>
      </div>
    </div>
  </mt-popup>
</template>
<script>
import { Popup } from 'mint-ui'

export default {
  name: 'customPopup',
  mixins: [],
  components: {
    'mt-popup': Popup
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    confirmBtn: {
      type: Boolean,
      default: true
    },
    confirmBtnText: {
      type: String,
      default: ''
    },
    safeAreaInsetBottom: {
      type: Boolean,
      default: true
    },
    titleAlign: {
      type: String,
      default: 'center'
    },
    teleport: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      popupVisible: false
    }
  },
  computed: {},
  watch: {
    show (val) {
      this.popupVisible = val
      if (!val) {
        this.$emit('close')
      }
    }
  },
  filters: {},
  directives: {},
  created () {},
  mounted () {},
  methods: {}
}

</script>
<style lang="scss" scoped>
.popup-ui {
  width: 100%;
  border-radius: torem(8px) torem(8px) 0 0;
}

.popup-container {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: $pageBg;
  border-radius: torem(8px) torem(8px) 0 0;

  .popup-top {
    position: relative;
    display: flex;
    height: torem(50px);
    align-items: center;
    justify-content: space-between;
    padding: 0 torem(14px);
    background-color: #fff;
    border-radius: torem(8px) torem(8px) 0 0;
  }

  .title {
    flex: 1;
    font-size: torem(16px);
    font-weight: 600;
    line-height: torem(22px);
    text-align: center;
  }

  .icon-close {
    position: absolute;
    right: torem(14px);
    font-size: torem(24px);
  }

  .popup-main {
    flex: 1;
    overflow-y: auto;
  }

  .popup-bottom {
    display: flex;
    min-height: torem(90px);
    justify-content: space-between;
    padding: torem(8px) torem(14px) torem(38px);
    background-color: #fff;
    box-shadow: 0 torem(2px) torem(10px) 0 rgba(0, 0, 0, 0.08);

    button {
      width: 100%;
      height: torem(44px);
      border-radius: torem(44px);
      color: #fff;
      font-size: torem(16px);
    }

    .confirm-btn {
      background-color: $mainFont;
    }
  }
}
</style>
